import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-terms',
    templateUrl: './terms.component.html',
  styles: [
  ]
})
export class TermsPageComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
